<template>
  <div>
    <the-nav-bar :title="$t('messageHelper.name')"  ref="nav"/>
      <!-- load success -->
    <div class="success-wrapper">

      <!-- 发送失败或成功，重新发送 -->
      <div class="status-wrapper col-center" >

        <img  v-if="status=='success'" src="@/images/status-success.svg" alt="Success" class="icon" />
        <img  v-else src="@/images/status-failed.svg" alt="Failed" class="icon" />

                <span class="text">
          {{ $t('messageHelper.sendAgainInfo') }}
        </span>
        <span class="subtext">
         {{ message }}
        </span>
        <md-button type="primary" @click="goAgain">
          <span>{{ $t('messageHelper.sendAgainButton') }}</span>
        </md-button>
      </div>

    </div>

    <md-popup  class="inner-popup" v-model="isPopupShow" :mask-closable="true" >
      <md-popup-title-bar
        only-close
        :title="$t('messageHelper.name')"
        title-align="left"
        @cancel="hidePopUp()"
      ></md-popup-title-bar>
    <md-field :brief="$t('messageHelper.warnInfo')" class="body-wrapper">
      <p><a href="https://mixinmessenger.zendesk.com/hc/zh-cn/articles/8137572138644">Mixin Messenger下载页面</a></p>
     <template >
        <p class="text-info-title">{{$t('messageHelper.groupInfo')}}</p>
        <p v-if="groupName" class="text-group-name group-name-exist">{{groupName}}</p>
        <p v-else class="text-group-name group-name-no">{{defaultGroupName}}</p>
        
        <p class="text-info-title">{{$t('messageHelper.textInfo')}}</p>
        <md-textarea-item
        class="textarea-item"
        :autosize="true"
        v-model="textValue"
        :max-length="100"
        :max-height="150"
        :placeholder="$t('messageHelper.textInfoPlaceHolder')"
      >
        <template slot="footer">
        </template>
      </md-textarea-item>
  
        <p class="text-info-title">{{$t('messageHelper.photosInfo')}}</p>
        <md-field-item class="upload photos-class" >
          <div  slot="children" class="">
              <ul class="image-reader-list">
                  <li
                    class="image-reader-item"
                    v-for="(img, index) in photos"
                    :key="index"
                    :style="{
                      'backgroundImage': `url(${img})`,
                      'backgroundPosition': 'center center',
                      'backgroundRepeat': 'no-repeat',
                      'backgroundSize': 'cover'
                    }">
                    <md-tag
                      class="image-reader-item-del"
                      size="small"
                      shape="quarter"
                      fill-color="#111A34"
                      type="fill"
                      font-color="#fff"
                      @click.native="onDeleteImage(index)"
                    >
                      <md-icon name="close"></md-icon>
                    </md-tag>
                  </li>
                  <li class="image-reader-item add">
                    <md-image-reader
                      @select="onReaderSelect"
                      @complete="onReaderComplete"
                      @error="onReaderError"
                      size="8192"
                      is-multiple
                    ></md-image-reader>
                    <md-icon name="camera" size="md" color="#CCC"></md-icon>
                    <p>{{ $t('newSettings.upload') }}</p>
                  </li>
                </ul>
          </div>
         </md-field-item>
         
      </template>

      <div class="field-footer" slot="footer">
        <div class="info">
          {{ $t('messageHelper.uploadTips') }}
        </div>
        <div class="btn-wrapper">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="currentColor"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
        </div>
      </div>
    </md-field>

    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Popup,
  PopupTitleBar,
  Field,
  FieldItem,
  InputItem,
  Button,
  ImageReader,
  Icon,
  Tag,
  Toast,
  ActivityIndicator,
  Dialog,
  TextareaItem,
} from 'mand-mobile';
import imageProcessor from 'mand-mobile/components/image-reader/image-processor';
import postUserTempMessage from '@/api/post-user-temp-message';
import getUserCurrentConversations from '@/api/get-user-current-conversations';
import { mapState } from 'vuex';

export default {
  components: {
    TheNavBar,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [ActivityIndicator.name]: ActivityIndicator,
    [TextareaItem.name]: TextareaItem,
  },
  data() {
    return {
      isPopupShow: false,
      groupName: '',
      status: '',
      textValue: '',
      photos: [],
      conversationId:'',
      uuids:[],
      isSubmitting: false,
      isRemoving: false,
      btnDisabled: false,
      validate: false,
      message:'',
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      navLang: state => state.navLang,
      userInfo: state => state.userInfo,
      serviceUuid: state => state.serviceUuid,
      defaultGroupName(){
        if(this.navLang=='zh-cn'){
          return '当前无交易群聊';
        }
        return 'No Trading Group';
      },
    }),
  },
  created(){
    this.isPopupShow = true;
    getUserCurrentConversations().then(data => 
    {
      this.groupName = data.groupName;     
      this.conversationId = data.conversationId;
      this.uuids = data.uuids; 
    }).catch(err => {
      Dialog.alert({
        icon: 'fail',
        title: this.$t('error.occurs'),
        content: err.message,
        confirmText: this.$t('common.confirm'),
      });
      this.$router.go(-1);
    });
  },
  mounted() {
    
  },
  methods: {
    hidePopUp() {
      this.goBack();
    },
    goAgain() {
      this.isPopupShow =true;
    },
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    onReaderSelect() {
      Toast.loading('loading...');
    },
    onReaderComplete(name, { dataUrl }) {
      const imageList = this.photos || [];
      if(imageList.length ===3){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('messageHelper.photosLimit'),
          confirmText: this.$t('common.confirm'),
        });
        Toast.hide();
        return;
      }
      imageProcessor({
        dataUrl,
        width: 768,
        quality: 1,
      }).then(({dataUrl}) => {
        dataUrl && imageList.push(dataUrl);
        this.photos = imageList;

        Toast.hide();
      }).catch(err => {
        Toast.failed(err.message);
      }); 
        
    },
    onReaderError(name, {msg}) {
      Toast.failed(msg);
    },
    onDeleteImage(index) {
      const imageList = this.photos || [];
      imageList.splice(index, 1);
      this.photos = imageList;
    },
    onSubmit() {
      if(this.conversationId ==undefined || this.conversationId.length ==0){
        return;
      }
      if(this.textValue.length ==0 && this.photos.length ==0){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('messageHelper.submitErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      }
      // if(this.photos.length ==0){
      //   Dialog.alert({
      //     icon: 'fail',
      //     title: this.$t('error.occurs'),
      //     content: this.$t('newSettings.kycAdv.photosEmptyErr'),
      //     confirmText: this.$t('common.confirm'),
      //   });
      //   return; 
      // }
      this.isSubmitting = true;
      let params = {
        textValue: this.textValue,
        photos: this.photos,
        conversationId: this.conversationId,
        uuids: this.uuids,
      };

      postUserTempMessage(params)
        .then(data => {
          this.isSubmitting = false;
          const d = data.data;
          this.status = d.status;
          this.message = d.message;
          this.isPopupShow =false;
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    copy(source, target) {
      Object.entries(source).forEach(([key]) => {
        source[key] = target[key];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .md-popup
    top: 10vh;
.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }

}
>>>.md-field-header
     margin-bottom: 0;

.text-info-title
  font-size: 3.73vw;
  font-weight: bold;
  margin-top: 3vw;

.text-group-name
  font-size: 3.33vw;
  margin-top: 3vw;
  color: green;

.group-name-no
  color: red !important;

.textarea-item
  background-color: #f3f3f6 !important;
  border: 0.27vw solid #f3f3f6;
  border-radius: 1.67vw;
  margin-top: 3vw;

.body-wrapper {
  padding-bottom: 20vw;

  .md-field-item {
    margin-bottom: 3.2vw;
  }

  & >>> {
    .md-field-item-content {
      height: 17.07vw;
      min-height: 0;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      width: 53.6vw;
      text-align: right;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      padding: 0 2.67vw;
      background: #f8fbfc;
    }

    .md-field-item-children {
      top: 100%;
      z-index: 10;
      margin-top: 0;
    }
  }

  .upload {
    & >>> {
      .md-field-item-content {
        height: auto;
        align-items: flex-start;
      }

      .md-field-item-title {
        margin-top: 5.33vw;
        width: 40vw;
      }

      .md-field-item-control {
        width: 40vw;
        flex: 0 0 auto;
      }
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      margin-top: 2.67vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      height: 40vw;
      background: #f8fbfc;
      color: #BCC7CB;
      overflow: hidden;

      .preview-img {
        width: 100%;
        line-height: 40vw;
        vertical-align: middle;
      }

      .icon {
        width: 14vw;
        height: 14vw;
      }
    }
  }

  .info {
    margin-top: 4.8vw;
    color: #84969c;
  }

  .btn-wrapper {
    margin-top: 9.6vw;

    .md-button {
      margin-bottom: 4.8vw;
    }

    & >>> .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}

.image-reader-list
  float left
  width 100%
  padding-left 0
  .image-reader-item
    position relative
    float left
    width 23.5%
    padding-bottom 23.5%
    margin-bottom 2%
    margin-right 2%
    background #FFF
    box-shadow 0 5px 20px rgba(197, 202, 213, .25)
    box-sizing border-box
    list-style none
    border-radius 4px
    background-size cover
    &:nth-of-type(4n)
      margin-right 0
    &.add
      .md-icon
        position absolute
        top 40%
        left 50%
        transform translate(-50%, -50%)
        opacity .5
      p
        position absolute
        top 50%
        left 0
        width 100%
        margin-top 15px
        font-size 22px
        color #CCC
        text-align center
    .image-reader-item-del
      position absolute
      top 0
      right 0
      z-index 3
      opacity .8
      .md-icon-close
        font-size 24px
</style>
